import { memo, type ReactNode } from "react";

import { Row } from "@narmi/design_system";

import styles from "../../SearchBar.module.scss";

interface MultiRowProps {
  title: string;
  subtitle: string;
  onClickRow: () => void;
  amount?: ReactNode;
  leftItem?: ReactNode;
}

const MultiRow = ({
  title,
  subtitle,
  amount,
  onClickRow,
  leftItem,
}: MultiRowProps) => (
  <div onClick={onClickRow}>
    <Row alignItems="center" gapSize="s">
      {leftItem && <Row.Item shrink>{leftItem}</Row.Item>}
      <Row.Item className={styles["results-multi-row-title-container"]}>
        <span className={styles["results-monetary-title"]}>{title}</span>
        <span className={styles["results-monetary-subtitle"]}>{subtitle}</span>
      </Row.Item>
      {amount && <Row.Item shrink>{amount}</Row.Item>}
    </Row>
  </div>
);

export default memo(MultiRow);
